export default __webpack_public_path__ + "19ff70e8ec4321310260cdf97baeff3e.svg";